'use strict';exports.__esModule = true;var loginType = exports.loginType = {
  LOGIN_VIA_PASSWORD: 'loginViaPassword',
  LOGIN_VIA_SMS: 'loginViaSMS' };

var loginTypeOptions = exports.loginTypeOptions = [
{
  name: loginType.LOGIN_VIA_PASSWORD,
  label: loginType.LOGIN_VIA_PASSWORD },

{
  name: loginType.LOGIN_VIA_SMS,
  label: loginType.LOGIN_VIA_SMS }];


//////////////////
// WEBPACK FOOTER
// ./src/containers/loginContainer/constants.js
// module id = 1262
// module chunks = 0